import React, { Component } from 'react';
import {
	// Button,
	Card,
	// CardActions,
	Divider
} from 'material-ui';
import JobCardHeader from './JobCardHeader';
import JobCardMedia from './JobCardMedia';
import JobCardContent from './JobCardContent';
import JobCardMapExpander from './JobCardMapExpander';
import AddressLinkBar from './AddressLinkBar';

export default class JobContainer extends Component {
	render() {
		const {
			loading,
			job,
			status,
			wrap,
			media,
			header,
			content,
			mapExpander,
			addressBar,
			uid,
			oid,
			fav
		} = this.props;
		return (
			<Card className={!!loading ? 'card skeletonCard' : 'card'}>
				{!!media && <JobCardMedia loading={loading} job={job} />}
				{!!header && (
					<JobCardHeader loading={loading} job={job} status={status} />
				)}
				{!!header && !!content && <Divider light />}
				{!!header &&
					!!(!content && (!!mapExpander || !!addressBar)) && <Divider light />}
				{!!content && (
					<JobCardContent loading={loading} job={job} wrap={wrap} />
				)}

				{!!mapExpander &&
					!loading && (
						<JobCardMapExpander
							job={job}
							uid={uid}
							oid={oid}
							fav={fav}
							location={job.location}
						/>
					)}
				{!!addressBar && !loading && <AddressLinkBar location={job.location} />}
			</Card>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/JobContainer.js